import { configureStore } from '@reduxjs/toolkit'
import {thunk} from 'redux-thunk';
import simulationCommonSlicer from '../slices/simulationCommonSlicer';
import simulationEntriesSlicer from '../slices/simulationEntriesSlicer';
import simulationPlotSlicer from '../slices/simulationPlotSlicer';
import simulationStratgySlicer from '../slices/simulationStratgySlicer';
import newsFeederSlicer from '../slices/newsFeederSlicer';
import streamCryptoInfoSlicer from '../slices/streamCryptoInfoSlicer';
import emaSelectionSlicer from '../slices/emaSelectionSlicer';
import sellStrategySettingsSlicer from '../slices/sellStrategySettingsSlicer';
import buyStrategySettingsSlicer from '../slices/buyStrategySettingsSlicer';
import entryPanelSlicer from '../slices/entryPanelSlicer';
import indicatorsPlotSlicer from '../slices/indicatorsPlotSlicer';
import globalDataSlicer from '../slices/globalDataSlicer';
import floatDotSlicer from '../slices/floatDotSlicer';
import mySpaceSlicer from '../slices/mySpaceSlicer';


const store = configureStore({ 
    reducer: {
        simulationCommon: simulationCommonSlicer,
        simulationEntries: simulationEntriesSlicer,
        simulationPlot: simulationPlotSlicer,
        simulationStratgy: simulationStratgySlicer,
        newsFeeder: newsFeederSlicer,
        streamCryptoInfo: streamCryptoInfoSlicer,
        emaSelection: emaSelectionSlicer,
        sellStrategySettings: sellStrategySettingsSlicer,
        buyStrategySettings: buyStrategySettingsSlicer,
        entryPanel : entryPanelSlicer,
        indicatorsPlot : indicatorsPlotSlicer,
        globalData : globalDataSlicer,
        floatDot : floatDotSlicer,
        mySpace : mySpaceSlicer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk)
})

export default store;


